import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter, asyncRouterMap } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    hotel_no: "",
    renter_no: "",
    menulist: []
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_MENULIST: (state, menulist) => {
    state.menulist = menulist;
  },
  SET_HOTEL_NO: (state, hotel_no) => {
    state.hotel_no = hotel_no;
  },
  SET_RENTER_NO: (state, renter_no) => {
    state.renter_no = renter_no;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, code } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, code: code })
        .then(response => {
          const { data } = response;
          commit("SET_TOKEN", data.token); // commit存储
          setToken(data.token);
          resolve(); // promise（异步操作）的resolve：将对象的状态-->‘未完成’变为‘成功’
        })
        .catch(error => {
          reject(error); // promise（异步操作）的reject：将对象的状态-->‘未完成’变为‘失败’
        });
    });
  },

  getApiToken({ commit }, data) {
    // console.log('xx:',data.data)
    commit("SET_TOKEN", data.data.token); // commit存储
    setToken(data.data.token);
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { data } = response;
          if (!data) {
            reject("Verification failed, please Login again.");
          }
          const realname = data.username;
          const hotel_no = data.hotel_no;
          const renter_no = data.renter_no;
          commit("SET_NAME", realname); // 存储
          commit("SET_HOTEL_NO", hotel_no);
          commit("SET_RENTER_NO", renter_no);
          commit("SET_AVATAR", "");
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getPermissionMenuList({ commit }, tempmenulist) {
    console.log("挂载路由：", tempmenulist);
    /* console.log('原有路由：', asyncRouterMap) */
    const menulist = [];
    //  console.log(asyncRouterMap, tempmenulist.roles)
    // 一级菜单权限判断
    asyncRouterMap.forEach((row, i) => {
      // console.log(row, i, row.meta.pop)
      // 有在权限列表中，或pop=F不需要判断权限或是隐藏路由则挂载
      if (
        tempmenulist.roles.indexOf(row.name) > -1 ||
        row.meta.pop === "F" ||
        row.hidden === true
      ) {
        // console.log('存在：', row.name)
        const tempRow = row;
        tempRow.children_temp = [];
        if (row.children) {
          // console.log('row.children', row.children)

          // 二级菜单权限判断
          row.children.forEach((chRow, n) => {
            // 有在权限列表中，或pop=F不需要判断权限或是隐藏路由则挂载
            if (
              tempmenulist.roles.indexOf(chRow.name) > -1 ||
              chRow.meta.pop === "F" ||
              chRow.hidden === true
            ) {
              tempRow.children_temp.push(chRow);
            }
          });
        }

        if (tempRow.children_temp) tempRow.children = tempRow.children_temp;
        menulist.push(tempRow);
        // console.log('新的路由：', tempRow)
      }
    });
    commit("SET_MENULIST", menulist);
    return "";
  },

  /* convertTree(){

  }, */

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          commit("RESET_STATE");
          resolve();
          const url = window.location.href;
          const data = url.split("/");
          const newlist = data[0] + "/" + data[1] + "/" + data[2];
          // console.log('newlist:',newlist)
          window.location.href = newlist;
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  }
};

export default {
  namespaced: true, // namespaced: true 的方式使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接。
  state,
  mutations,
  actions
};
